
	import {
		IonContent,
		IonGrid,
		IonRow,
		IonCol,
		IonButton,
		IonAlert,
		modalController,
		IonIcon,
		IonCheckbox,
	} from "@ionic/vue";
	import { IonInput } from "@ionic/vue";

	import { defineComponent, ref } from "vue";
	import { LoginUtility } from "../LoginUtility/LoginUtility";
	import { useRouter } from "vue-router";
	import { useApplicationStore } from "@/stores/ApplicationStore";

	export default defineComponent({
		name: "LoginPage",
		components: {
			IonContent,
			IonGrid,
			//IonIcon,
			IonRow,
			IonCol,
			IonInput,
			IonButton,
			IonAlert,
			IonCheckbox,
		},
		setup() {
			const router = useRouter();
			const appStore = useApplicationStore();
			const backgroundStyle = ref({
				background: `url(${appStore.$LOGIN_BACKGROUND_IMAGE}) no-repeat center center fixed`,
				height: "100%",
				"-webkit-background-size": "cover",
				"-moz-background-size": "cover",
				"-o-background-size": "cover",
				"background-size": "cover",
				color: "#ffffff",
			});

			return { router, appStore, backgroundStyle };
		},
		data() {
			return {
				model: {
					username: "",
					password: "",
				},
				resetEmail: "",
				showResetPassword: false,
				showPassword: false, // Add this line
				AlertMessage: "",
				isOpenRef: false,
			};
		},
		computed: {
			passwordFieldType() {
				// Add this computed property
				return this.showPassword ? "text" : "password";
			},
		},
		methods: {
			Login_click() {
				if (!this.model.username) {
					this.ShowAlert(true, "Inserire un utente");
					return;
				}
				if (!this.model.password) {
					this.ShowAlert(true, "Inserire una password");
					return;
				}
				const loginUtility = new LoginUtility();
				const store = useApplicationStore();
				loginUtility
					.LogIn(
						this.model.username,
						this.model.password,
						this.$API_AUTH_URL,
						this.$API_DBOX_URL
					)
					.finally(() => {
						if (store.$APP_READY) {
							this.$router.push("/mainhome");
							modalController.dismiss();
						} else {
							this.ShowAlert(
								true,
								"Errore di login controllare username e password"
							);
						}
					});
			},
			togglePasswordVisibility() {
				// Add this method
				this.showPassword = !this.showPassword;

				
			},
			ResetPassword_click() {
				if (!this.resetEmail) {
					this.ShowAlert(true, "Inserire un'email");
					return;
				}
				// Implement the password reset functionality here
				console.log("Reset password for:", this.resetEmail);
				this.ShowAlert(true, "Reset link inviato al tuo indirizzo email");
			},
			ShowAlert(state: boolean, message?: string) {
				this.AlertMessage = message ? message : "";
				this.isOpenRef = state;
			},
		},
	});
